// extracted by mini-css-extract-plugin
export var numpadContainer = "_op-1";
export var phoneButton = "_op-0";